/* RESPONSIBLE TEAM: team-automation-foundations */
import IntercomRoute from 'embercom/routes/base/intercom-route';
import { inject as service } from '@ember/service';
import type RouterService from '@ember/routing/router-service';

export default class ResolutionBotBehaviorsRoute extends IntercomRoute {
  @service declare router: RouterService;

  analytics = {
    section: 'resolution-bot',
    place: 'behaviors',
  };

  redirect() {
    this.router.replaceWith('apps.app.automation.fin-ai-agent.profiles');
  }
}
